import ApiService from './api'

const BASE_URL = '/hr/jobs'

export const jobService = {
  // Get all jobs
  getAllJobs: async () => {
    try {
      const response = await ApiService.get(BASE_URL)
      return response
    } catch (error) {
      console.error('Error fetching jobs:', error)
      throw error
    }
  },

  // Create a new job
  createJob: async (jobData) => {
    try {
      const response = await ApiService.post(BASE_URL, jobData)
      return response
    } catch (error) {
      console.error('Error creating job:', error)
      throw error
    }
  },

  // Update a job
  updateJob: async (jobId, jobData) => {
    try {
      const response = await ApiService.patch(`${BASE_URL}/${jobId}`, jobData)
      return response
    } catch (error) {
      console.error('Error updating job:', error)
      throw error
    }
  },

  // Delete a job
  deleteJob: async (jobId) => {
    try {
      const response = await ApiService.delete(`${BASE_URL}/${jobId}`)
      
      // Handle different possible success responses for DELETE requests
      // Some APIs return empty response, 204 status, or success object
      if (response === '' || response === null || response === undefined) {
        return { success: true, message: 'Job deleted successfully' }
      }
      
      return response
    } catch (error) {
      console.error('Error deleting job:', error)
      
      // Check if it's actually a successful delete (204 No Content)
      if (error.response?.status === 204) {
        return { success: true, message: 'Job deleted successfully' }
      }
      
      throw error
    }
  },

  // Get job by ID
  getJobById: async (jobId) => {
    try {
      const response = await ApiService.get(`${BASE_URL}/${jobId}`)
      return response
    } catch (error) {
      console.error('Error fetching job:', error)
      throw error
    }
  }
}

export default jobService
